export const skills = {
  "Languages": ["Python", "JavaScript", "TypeScript", "C/C++", "SQL", "HTML/CSS"],
  "Frameworks & Tools": ["React", "Node.js", "Express", "Flask", "Firebase", "MongoDB", "Pandas", "Tableau", "Figma"],
  "Development Practices": ["Agile/Scrum", "Automation", "Regression Testing", "User-Centered Design", "Data Visualization"]
};

